import React from "react";
import * as Icons from "lucide-react";

export function CategoryIcon({ name, className }) {
  const Ico = Icons[name] || Icons.Package;
  return <Ico className={className} />;
}
